var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.546-.182h21.818v16.364H.546V-.182Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.824-.182 4.159 3.085 4.142-3.085h1.33V.875L7.364 3.926l4.09 3.034V8h-1.363l-4.09-3.051L1.925 8H.546V6.977l4.073-3.034L.546.91V-.18h1.278Z",
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.773 4.608 3.682 2.71V8l-4.62-3.392h.938Zm-3.137.34.103.597L1.466 8h-.92l4.09-3.051Zm6.819-5.13v.051L7.21 3.074l.034-.75 3.358-2.506h.853Zm-10.91 0 4.074 3H3.597L.546.534v-.716Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.653-.182V8h2.728V-.182H4.653ZM.546 2.545v2.728h10.909V2.545H.545Z",
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.546 3.108v1.636h10.909V3.108H.545Zm4.653-3.29V8h1.636V-.182H5.2Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.511 13.342-.698.089.075.699-.505-.491-.501.494.068-.699-.699-.082.59-.382-.372-.596.668.221.236-.664.242.661.665-.228-.365.6.593.378h.003Zm-.126-3.995.092-.444-.334-.306.45-.052.188-.412.187.412.45.052-.334.306.092.444-.395-.225-.396.225ZM14.836 7.3l-.692.075.062.692-.491-.494-.505.48.082-.692-.689-.092.59-.368-.358-.596.658.231.246-.65.228.657.661-.214-.371.59.583.381h-.004Zm6.948-1.118-.712.092.078.712-.515-.5-.511.504.072-.716-.713-.082.603-.392-.378-.61.682.228.238-.675.246.675.678-.235-.375.614.607.385Zm-3.276-2.847-.706.079.065.709-.501-.505-.515.491.082-.705-.706-.096.604-.375-.365-.61.671.235.25-.665.231.672.675-.222-.378.6.593.392Zm-9.985 9.631-1.562.184.157 1.565L6 13.61 4.875 14.71l.167-1.565-1.561-.197 1.326-.846-.818-1.343 1.486.511.539-1.48.528 1.484 1.49-.501-.829 1.336 1.323.856-.003.003Z",
    fill: "#EEF2F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.546 -.182)",
    d: "M0 0h21.818v16.364H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudFlag);
export default __webpack_public_path__ + "static/media/aud-flag.aa79c759a44ce29b8bce9e62490dd64e.svg";
export { ForwardRef as ReactComponent };